import { render } from "./QuestionSection.vue?vue&type=template&id=1f5510ba&scoped=true"
import script from "./QuestionSection.vue?vue&type=script&lang=js"
export * from "./QuestionSection.vue?vue&type=script&lang=js"

import "./QuestionSection.vue?vue&type=style&index=0&id=1f5510ba&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f5510ba"]])

export default __exports__